import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";

class  DashboardTile extends Component {
    constructor(...args) {
        super(...args);
    }
    render() {

        return (
            <div   class="card-stats mb-4 mb-xl-0 card" onClick={()=>
                    {
                    }
                }>
            <div class="card-body lund"   
                style={  { backgroundColor: this.props.TitleId === 1 ? '#f8bcf8' : '#92dada' }} >
              <div class="row">
                <div class="col">
                <div style={{textAlign:'center'}}>
                  <h5 class="text-uppercase text-muted mb-0 card-title">
                    {this.props.Header}
                  </h5>
                  </div>
                  <div style={{textAlign:'center'}}>
                  <span class="h2 font-weight-bold mb-0">{this.props.HeaderData}</span>
                  </div>
                </div>
                <div class="col-auto col">
                  <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
                    <i class="fas fa-chart-bar"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="text-success mr-2">
                  <i class="fa fa-arrow-up"></i> {this.props.Subtext}
                </span>{" "}
                <span class="text-nowrap">{this.props.Footer}</span>
              </p>
            </div>
          </div>
        );
    }
}

export default withRouter(DashboardTile) 